import api from "../api/axios";

export const getDashboardStats = (branchCode = "") => {
  return api.get(`/api/dashboard/stats?branchCode=${branchCode}`);
};
